<div class="projects-list-container">
    <table class="table table-striped" *ngIf="projects.length; else emptyProjects">
        <thead>
            <tr>
                <th>
                    <button type="button" class="sort-button" (click)="onSort('projectName')">
                        Project {{ sortIndicator('projectName') }}
                    </button>
                </th>
                <th>
                    <button type="button" class="sort-button" (click)="onSort('projectType')">
                        Type {{ sortIndicator('projectType') }}
                    </button>
                </th>
                <th>
                    <button type="button" class="sort-button" (click)="onSort('projectStage')">
                        Stage {{ sortIndicator('projectStage') }}
                    </button>
                </th>
                <th>
                    <button type="button" class="sort-button" (click)="onSort('startupYear')">
                        Startup {{ sortIndicator('startupYear') }}
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let project of sortedProjects" (click)="selectProject(project)"
                [class.selected-row]="isSelected(project)">
                <td>{{ project.projectName }}</td>
                <td>{{ project.projectType }}</td>
                <td>{{ project.projectStage }}</td>
                <td>{{ project.startupYear }}</td>
            </tr>
        </tbody>
    </table>
    <ng-template #emptyProjects>
        <div>No projects available for this selection.</div>
    </ng-template>
</div>